import React from 'react';
import {useControllerProps} from '../Widget/ControllerContext';
import {CheckoutSlot} from '../CheckoutSlot';
import {SlotId} from '../../../domain/utils/slotId';
import {classes} from './Header.st.css';

export const HeaderSlot: React.FC = () => {
  const {slotsStore, isOneColumnView} = useControllerProps();

  if (!slotsStore) {
    return null;
  }

  const getHeaderCheckoutSlotClassName = () => {
    if (isOneColumnView) {
      return classes.headerCheckoutSlotMobile;
    }
    return classes.headerCheckoutSlot;
  };

  return <CheckoutSlot className={getHeaderCheckoutSlotClassName()} slotId={SlotId.HeaderCheckoutSlot} />;
};
